import { render } from "./instrument.vue?vue&type=template&id=495c5864&scoped=true"
import script from "./instrument.vue?vue&type=script&lang=js"
export * from "./instrument.vue?vue&type=script&lang=js"

import "./instrument.vue?vue&type=style&index=0&id=495c5864&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495c5864"]])

export default __exports__